<template>
  <div v-if="type">
    <DataInput
      type="model"
      name="vacancyTextTemplate"
      :gql-query="query"
      :reduce="el => el"
      :label="label"
      @input="onSelect"
    />
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import gql from "graphql-tag";

export default {
  components: {
    DataInput
  },
  props: {
    type: { type: String, default: null },
    label: { type: String, default: null }
  },
  computed: {
    query() {
      return gql`
        query VacancyTextTemplate($search: String) {
          vacancyTextTemplates(page: 1, search: $search, type: ${this.type}) {
            results {
              id
              name
              text
            }
            total
          }
        }
      `;
    }
  },
  methods: {
    onSelect(v) {
      this.$emit("textChoosen", v.text);
    }
  }
};
</script>
